/* Welcome pop-up.
   - Opens only when the address contains ?<trigger> (default "welcome"), e.g. /collections/all?welcome=1
   - The ?welcome part is removed from the address bar once it opens, so a refresh does not open it again
   - Close with the X, the Esc key, or by clicking outside the card. "Copy" puts the coupon code on the clipboard. */
(function () {
  function init(dialog) {
    if (!dialog || dialog.getAttribute('data-inited')) return;
    dialog.setAttribute('data-inited', '1');
    var param = dialog.getAttribute('data-trigger') || 'welcome';
    var url = new URL(window.location.href);
    var asked = url.searchParams.has(param);

    function closePopup() {
      if (dialog.open) dialog.close();
    }
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('welcome-popup-open');
    });
    dialog.querySelector('[data-close]').addEventListener('click', closePopup);
    // click on the dark backdrop (outside the card) closes it
    dialog.addEventListener('click', function (e) {
      var card = dialog.querySelector('.welcome-popup__card');
      if (card && !card.contains(e.target)) closePopup();
    });

    var copy = dialog.querySelector('[data-copy]');
    var code = dialog.querySelector('[data-code]');
    if (copy && code) {
      copy.addEventListener('click', function () {
        var text = code.textContent.trim();
        var done = copy.getAttribute('data-done') || '✓';
        var original = copy.textContent;
        function feedback() { copy.textContent = done; setTimeout(function () { copy.textContent = original; }, 1800); }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(feedback, function () { fallback(text); feedback(); });
        } else { fallback(text); feedback(); }
      });
    }
    function fallback(text) {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) { /* ignore */ }
      document.body.removeChild(ta);
    }

    if (asked) {
      // remove ?welcome=1 so refreshing or sharing the page doesn't re-open it
      url.searchParams.delete(param);
      try { history.replaceState(null, '', url.pathname + (url.search || '') + url.hash); } catch (e) { /* ignore */ }
      // pre-load the sticker images (they are lazy inside a closed dialog), then open together with the card
      var imgs = Array.prototype.slice.call(dialog.querySelectorAll('img'));
      var loads = imgs.map(function (img) {
        img.loading = 'eager';
        return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
      });
      var timeout = new Promise(function (r) { setTimeout(r, 2000); });
      Promise.race([Promise.all(loads), timeout]).then(function () {
        setTimeout(function () {
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
            document.documentElement.classList.add('welcome-popup-open');
          }
        }, 300);
      });
    }
  }

  function boot() { init(document.querySelector('[data-welcome-popup]')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
